export const EASY_CODING_DIR = ".easy-coding";
export const CONFIG_FILE = "config.yaml";
export const INSTALL_MANIFEST_FILE = "install-manifest.json";
// ec-init owns this file; the CLI never reads or writes it, only preserves it on clear.
export const PROJECT_CONFIG_FILE = "project.yaml";
export const SESSIONS_DIR = "sessions";
export const TASKS_DIR = "tasks";
export const PROJECT_INIT_TASK_ID = "project-init";
export const MEMORY_DIR = "memory";
export const SPEC_DIR = "spec";
export const MAIN_SPEC_DIR = "main";
export const DEV_SPEC_DIR = "dev";

export const TEMPLATES_DIR = "templates";

export const SESSIONS_GITIGNORE_ENTRY = ".easy-coding/sessions/";
export const HOOK_BYTECODE_GITIGNORE_ENTRY = "__pycache__/";

export const GENERATED_REGION_START =
  "<!-- ═══ easy-coding-harness generated (DO NOT EDIT BETWEEN MARKERS) ═══ -->";
export const GENERATED_REGION_END = "<!-- ═══ end easy-coding-harness generated ═══ -->";
